<template>
    <a class="fond" href="http://presidentfoundation.kz/" target="_blank">
		<div class="container no-padding">
			<img :src="logo" class='foundation-logo'>
			<span class='text'>{{tr.fond_full_name}}</span>
		</div>
	</a>
</template>
<script>
export default {

    name: 'fond',

    data() {
        return {
            logo: require("../assets/img/fond.svg")
        }
    }
}
</script>
<style lang="css" scoped>
.foundation-logo {
    float: left;
    vertical-align: middle;
    width: 80px;
}

.fond {
    background: white;
    padding: 18px 0;
    overflow: hidden;
    display: block;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    transition: 0.3s all ease;
    border-top: 1px solid lightgrey;
}

.fond:hover {
    cursor: pointer;
    background: #fafafa;
}

.fond img {
    float: left;
    vertical-align: middle;
}

.fond .text {
    vertical-align: middle;
    padding-left: 120px;
    padding-top: 28px;
    display: block;
    font-size: 24px;
    text-align: center;
}

a {
    color: #002e5b;
}

@media(max-width:992px) {
    .fond .text {
        padding-left: none;
        text-align: center;
        padding-left: 0;
        padding-bottom: 12px;

    }

    .fond img {
        float: none;
        display: block;
        margin: auto;
    }
}
</style>